import { render, staticRenderFns } from "./LicenseGate.vue?vue&type=template&id=4a57e997"
import script from "./LicenseGate.vue?vue&type=script&lang=js"
export * from "./LicenseGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports